import { Keys } from '@eih-netbroker/common';

const betMarketCodes = new Set(Keys.Markets.dataProviderMicList.bet);
const xetraFrMarketCodes = new Set(Keys.Markets.dataProviderMicList.xetraFr);
const usaMarketCodes = new Set(Keys.Markets.dataProviderMicList.usa);

export { betMarketCodes, usaMarketCodes, xetraFrMarketCodes };
